import {
  armarParametrosBuscadorMesa,
  armarParametrosMesaEntrada,
  armarParametrosMesaEntradaBuscador,
} from '../../helpers/parametros';
import { handleErrorApi } from '../../helpers/randoms';
import MesaEntradaService from '../../services/MesaEntradaService';
import { types } from '../../types/types';
import { MENU_MESA_ENTRADA, MENU_TIPO_EXPEDIENTE } from '../../utils/constants';
import { startAlerta } from '../ui/alertas';
import { finishSpinner, startSpinner } from '../ui/spinner';

// Comprobantes
export const cleanComprobantesMesaEntrada = () => ({
  type: types.comprobanteMesaEntradaClean,
});
export const startComprobantesMesaEntrada = () => ({
  type: types.comprobanteMesaEntradaStart,
});
export const errorComprobantesMesaEntrada = () => ({
  type: types.comprobanteMesaEntradaError,
});
export const getComprobantesMesaEntrada = (body) => ({
  type: types.comprobanteMesaEntradaSuccess,
  payload: body,
});
export const postComprobante = (body) => ({
  type: types.comprobanteMesaEntradaGuardar,
  payload: body,
});
export const deleteComprobante = (id) => ({
  type: types.comprobanteMesaEntradaEliminar,
  payload: id,
});
export const deleteComprobanteDirecto = (id) => ({
  type: types.comprobanteMesaDirectoEliminar,
  payload: id,
});
export const updateComprobante = (data) => ({
  type: types.comprobanteMesaEntradaModificar,
  payload: data,
});

// Proformas
export const cleanProformasMesaEntrada = () => ({
  type: types.proformaMesaEntradaClean,
});
export const startProformasMesaEntrada = () => ({
  type: types.proformaMesaEntradaStart,
});
export const errorProformasMesaEntrada = () => ({
  type: types.proformaMesaEntradaError,
});
export const getProformasMesaEntrada = (body) => ({
  type: types.proformaMesaEntradaSuccess,
  payload: body,
});
export const deleteProformaMesaEntrada = (id) => ({
  type: types.proformaMesaEntradaDelete,
  payload: id,
});
export const tomarProformaMesaEntrada = (value) => ({
  type: types.tomarProforma,
  payload: value,
});
export const liberarProformaMesaEntrada = () => ({
  type: types.liberarProforma,
});
export const setMenuProformaMesaEntrada = (value) => ({
  type: types.setMenuProforma,
  payload: value,
});

// Tomar Comprobante
export const tomarComprobanteMesaEntrada = (body) => ({
  type: types.comprobanteTomar,
  payload: body,
});
export const liberarComprobanteMesaEntrada = () => ({
  type: types.comprobanteLiberar,
});

// Datos Comprobantes
export const startDatos = () => ({ type: types.datosComprobanteStart });
export const errorTiposComprobante = () => ({
  type: types.tipoComprobanteError,
});
export const errorTiposFactura = () => ({ type: types.tipoFacturaError });
export const errorProcedencias = () => ({ type: types.procedenciaError });
export const getTiposComprobante = (body) => ({
  type: types.tipoComprobanteSuccess,
  payload: body,
});
export const getTiposFactura = (body) => ({
  type: types.tipoFacturaSuccess,
  payload: body,
});
export const getProcedencias = (body) => ({
  type: types.procedenciaSuccess,
  payload: body,
});
export const setEstadosComprobante = (estado) => ({
  type: types.comprobanteMesaEntradaActualizacionEstado,
  payload: estado,
});
export const getUsuarioLiquidaciones = (body) => ({
  type: types.usuarioLiquidacionesSuccess,
  payload: body,
});
export const errorUsuarioLiquidaciones = () => ({
  type: types.usuarioLiquidacionesError,
});
export const setUsuarioLiquidaciones = (value) => ({
  type: types.usuarioLiquidacionesError,
  payload: value,
});

// Documentacion Comprobantes
export const insertDocumentacionComprobante = (docu) => ({
  type: types.documentacionMesaEntradaInsert,
  payload: docu,
});
export const deleteDocumentacionComprobante = (docu) => ({
  type: types.documentacionMesaEntradaEliminar,
  payload: docu.idDocumentacionComprobante,
});

// Screen
export const setRecepcionMenu = (menu) => ({
  type: types.recepcionComprobanteSetMenu,
  payload: menu,
});
export const setTipoEfectorMenu = (tipoEfector) => ({
  type: types.tipoEfectorMenuSet,
  payload: tipoEfector,
});
export const setTipoComprobanteDocumentacionMenu = (
  tipoComprobanteDocumentacion,
) => ({
  type: types.setMenuComprobanteDocumentacion,
  payload: tipoComprobanteDocumentacion,
});
export const setActiveBreadcrumbMesaEntrada = (activeBreadcrumb) => ({
  type: types.setActiveBreadcrumbMesa,
  payload: activeBreadcrumb,
});
export const setActiveStepMesaEntrada = (step) => ({
  type: types.mesaEntradaSetStep,
  payload: step,
});

// Actions
export const getExpedientes = () => async (dispatch, getState) => {
  dispatch(startSpinner());
  dispatch(startComprobantesMesaEntrada());
  try {
    const { dataContrato } = getState().contrataciones;
    const { recepcionMenu, tipoComprobanteDocumentoMenu } =
      getState().mesaEntrada;
    const response =
      recepcionMenu === MENU_TIPO_EXPEDIENTE.DOCUMENTO
        ? await MesaEntradaService.getComprobantesDocumento(
          tipoComprobanteDocumentoMenu,
        )
        : await MesaEntradaService.getComprobantesPrestadores(
          dataContrato.idEfectorFacturacion,
        );
    const body = await response.json();
    if (response.ok) {
      dispatch(getComprobantesMesaEntrada(body));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(errorComprobantesMesaEntrada());
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los comprobantes',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const getProformas = () => async (dispatch, getState) => {
  dispatch(startSpinner());
  dispatch(startProformasMesaEntrada());
  try {
    const { dataContrato } = getState().contrataciones;
    const response = await MesaEntradaService.getComprobantesProformas(
      dataContrato.idEfectorFacturacion,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch(getProformasMesaEntrada(body));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(errorProformasMesaEntrada());
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los comprobantes',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const getComprobanteMesaEntradaGestion =
  (gestion) => async (dispatch, getState) => {
    dispatch(startSpinner());
    dispatch(startComprobantesMesaEntrada());
    try {
      const { activeBreadcrumb } = getState().mesaEntrada;
      const parametros = armarParametrosMesaEntrada(
        gestion.proveedor,
        gestion.idTipoEfector,
        gestion.fechaDesde,
        gestion.fechaHasta,
        activeBreadcrumb,
        gestion.tipoComprobanteDocumento,
        gestion.idEfectorFacturacion,
      );
      const response =
        activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES
          ? await MesaEntradaService.getComprobantesPrestadoresGestion(
            parametros,
          )
          : await MesaEntradaService.getComprobantesDocumentoGestion(
            parametros,
          );
      const body = await response.json();
      if (response.ok) {
        dispatch(getComprobantesMesaEntrada(body));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch(errorComprobantesMesaEntrada());
      handleErrorApi(
        dispatch,
        error,
        'Error al traer los comprobantes',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const buscadorComprobanteMesaEntradaGestion =
  (gestion, setInputValue) => async (dispatch, getState) => {
    dispatch(startSpinner());
    dispatch(startComprobantesMesaEntrada());
    try {
      ;
      const { activeBreadcrumb } = getState().mesaEntrada;
      const parametros = armarParametrosBuscadorMesa(
        gestion.idTipoEfector,
        activeBreadcrumb,
        gestion.tipoComprobanteDocumento,
        gestion.buscador,
      );
      const response =
        activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES
          ? await MesaEntradaService.getComprobantesPrestadoresGestionBuscador(
            parametros,
          )
          : await MesaEntradaService.getComprobantesDocumentoGestionBuscador(
            parametros,
          );
      const body = await response.json();
      if (response.ok) {
        dispatch(getComprobantesMesaEntrada(body));
        dispatch(finishSpinner());
        setInputValue('');
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch(errorComprobantesMesaEntrada());
      handleErrorApi(
        dispatch,
        error,
        'Error al traer los comprobantes',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const buscadorComprobanteMesaEntradaDirecto =
  (gestion, setInputValue) => async (dispatch, getState) => {
    dispatch(startSpinner());
    dispatch(startComprobantesMesaEntrada());
    try {
      const { activeBreadcrumb } = getState().mesaEntrada;
      const parametros = armarParametrosBuscadorMesa(
        gestion.idTipoEfector,
        activeBreadcrumb,
        gestion.tipoComprobanteDocumento,
        gestion.buscador,
      );
      const response = MesaEntradaService.getComprobantesPrestadoresGestionBuscador(parametros)

      const body = await response.json();
      if (response.ok) {
        dispatch(getComprobantesMesaEntrada(body));
        dispatch(finishSpinner());
        setInputValue('');
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch(errorComprobantesMesaEntrada());
      handleErrorApi(
        dispatch,
        error,
        'Error al traer los comprobantes',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const postComprobanteMesaEntrada =
  (data, stepperMenu) => async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { recepcionMenu } = getState().mesaEntrada;
      const menuPrestador = recepcionMenu === MENU_TIPO_EXPEDIENTE.PRESTADOR;
      const result = menuPrestador
        ? await MesaEntradaService.postComprobantePrestadores(data)
        : await MesaEntradaService.postComprobanteDocumento(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(tomarComprobanteMesaEntrada(body));
        dispatch(setActiveStepMesaEntrada(stepperMenu.DOCUMENTACION));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al guardar la comprobante',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const deleteComprobanteMesaEntrada = (data) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await MesaEntradaService.deleteComprobante(
        data.idExpediente,
        data,
      );
      const body = await result.json();
      if (result.ok) {
        if (data.gestion !== null) {
          dispatch(getComprobanteMesaEntradaGestion(data.gestion));
        } else {
          dispatch(deleteComprobante(data.idExpediente));
          dispatch(deleteProformaMesaEntrada(data.idExpediente));
        }
        dispatch(
          startAlerta(`Comprobante Eliminado`, 'success', 'Comando Exitoso'),
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al eliminar comprobante',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };
};

export const updateDestinoComprobante = (data) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await MesaEntradaService.updateComprobante(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(updateComprobante(data));
        dispatch(
          startAlerta(`Destino Modificado`, 'success', 'Comando Exitoso'),
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al modificar destino',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };
};

export const editarEstadoExpediente = (
  data,
  parametros,
  setSelected,
  retornar = false,
) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await MesaEntradaService.updateEstadoComprobante(
        data,
        retornar,
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(getComprobanteMesaEntradaGestion(parametros));
        dispatch(
          startAlerta(`Comprobante Enviado`, 'success', 'Comando Exitoso'),
        );
        setSelected([]);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al modificar destino',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };
};

export const getTipoComprobante = () => async (dispatch) => {
  dispatch(startSpinner());
  dispatch(startDatos());
  try {
    const response = await MesaEntradaService.getTipoComprobante();
    const body = await response.json();
    if (response.ok) {
      dispatch(getTiposComprobante(body));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(errorTiposComprobante());
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los tipos de comprobante',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const getTipoFactura = () => async (dispatch) => {
  dispatch(startSpinner());
  dispatch(startDatos());
  try {
    const response = await MesaEntradaService.getTipoFactura();
    const body = await response.json();
    if (response.ok) {
      dispatch(getTiposFactura(body));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(errorTiposFactura());
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los tipos de comprobante',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const getProcedencia = () => async (dispatch) => {
  dispatch(startSpinner());
  dispatch(startDatos());
  try {
    const response = await MesaEntradaService.getProcedencia();
    const body = await response.json();
    if (response.ok) {
      dispatch(getProcedencias(body));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(errorProcedencias());
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los tipos de comprobante',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const getTramites = () => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.datosExpedienteStart });
  try {
    const response = await MesaEntradaService.getTramites();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.tramitesSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch({ type: types.tramitesError });
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los tramites',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const getDestinos = () => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.datosExpedienteStart });
  try {
    const response = await MesaEntradaService.getDestinos();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.destinosSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch({ type: types.destinosError });
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los destinos',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const cleanSolic = () => ({ type: types.solicMesaEntradaClean });

export const getSolic =
  (idSolic, periodo, idTramite, setOpen) => async (dispatch, getState) => {
    dispatch(startSpinner());
    dispatch({ type: types.solicMesaEntradaStart });
    try {
      const { dataContrato } = getState().contrataciones;
      const response = await MesaEntradaService.getSolic(
        idSolic,
        periodo,
        dataContrato.idEfectorFacturacion,
        idTramite
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.solicMesaEntradaSuccess,
          payload: body,
        });
        setOpen(true);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.solicMesaEntradaError });
      handleErrorApi(
        dispatch,
        error,
        'Error al traer los nros de autorizacion',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

// Old Mesa
export const getUsuarioLiquidacionMesa =
  ({ setOpen, idEfectorFacturacion }) =>
    async (dispatch, getState) => {
      dispatch(startSpinner());
      try {
        const { dataContrato } = getState().contrataciones;
        const response = await MesaEntradaService.getUsuarioLiquidacion(
          idEfectorFacturacion
            ? idEfectorFacturacion
            : dataContrato.idEfectorFacturacion,
        );
        if (response.ok || response.status === 204) {
          const body =
            response.status === 204 ? 'No posee' : await response.json();
          dispatch(getUsuarioLiquidaciones(body));
          dispatch(finishSpinner());
          setOpen(true);
        } else {
          throw response;
        }
      } catch (error) {
        dispatch(finishSpinner());
        dispatch(errorUsuarioLiquidaciones());
        handleErrorApi(
          dispatch,
          error,
          'Error al traer usuario de liquidaciones ',
          'Ha ocurrido un error. Intente nuevamente',
        );
      }
    };


export const getComprobantesRemitos = (fechaDesde, fechaHasta, idTipoIngreso, generado, idArea, idSubArea) => async (dispatch) => {
  dispatch(startSpinner());
  dispatch(startDatos());
  try {
    const response = await MesaEntradaService.getComprobantesRemitos(fechaDesde, fechaHasta, idTipoIngreso, generado, idArea, idSubArea);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.getremitosSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(errorTiposComprobante());
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los comprobantes',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};


export const getComprobantesDocumentoRemitos = (fechaDesde, fechaHasta, idTipoIngreso, generado, idArea, idSubArea) => async (dispatch) => {
  dispatch(startSpinner());
  dispatch(startDatos());
  try {
    const response = await MesaEntradaService.getComprobantesDocumentoRemitos(fechaDesde, fechaHasta, idTipoIngreso, generado, idArea, idSubArea);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.getremitosSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(errorTiposComprobante());
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los comprobantes',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};



export const generarRemitoMesaEntrada = (data, nroRemito, setNroRemito) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await MesaEntradaService.generarRemitoMesa(data);
      const body = await result.json();
      
      if (result.ok) {
        if (nroRemito === null) {
          setNroRemito(body[0].nroRemito)
        }
        dispatch(
          startAlerta(`Remito Generado bajo el N° ${body[0].nroRemito}`, 'success', 'Comando Exitoso'),
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al generar remito',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };
};

//BUSCADOR NUEVO MESA ENTRADAS

export const getBuscadorMesaEntradas =
  (gestion) => async (dispatch, getState) => {
    dispatch(startSpinner());
    dispatch(startComprobantesMesaEntrada());
    try {
      const parametros = armarParametrosMesaEntradaBuscador(
        gestion.tipoConsulta,
        gestion.idEfectorFacturacion,
        gestion.idExpediente,
        gestion.idExpedienteSV,
        gestion.nroSucursal,
        gestion.nroFactura,
      );
   
      const response = await MesaEntradaService.getBuscadorMesaEntrada(parametros)
         
      const body = await response.json();
      if (response.ok) {
        dispatch(getComprobantesMesaEntrada(body));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch(errorComprobantesMesaEntrada());
      handleErrorApi(
        dispatch,
        error,
        'Error al traer los comprobantes',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };